/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class AppEnvironmentApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `AppEnvironmentModule.forRoot()`
 */
export interface AppEnvironmentApiConfigurationParams {
  rootUrl?: string;
}
